import React, { useState, memo } from 'react';
import { Stack } from '../ui-kit';
import { IconSpinner, IconPlay, IconStop, IconForwardFast } from '../ui-kit/icons';

const TableCell = ({ possessesSkill, membershipId, skillId, assignOverride, overrideEntry }) => {
  const [loading, setLoading] = useState(false);

  if (!possessesSkill && loading === false) {
    return null;
  }

  const update = async type => {
    setLoading(true);
    await assignOverride(membershipId, skillId, type);
    setLoading(false);
  };

  const mode = overrideEntry?.override_type || 'normal';

  const translations = I18n.t('incidents.fairness_suggestion.penalty_override');

  return (
    <Stack direction="horizontal" className="justify-content-center">
      {loading && <IconSpinner spin />}
      {!loading && (
        <>
          <IconStop
            className={mode === 'deprioritize' ? 'text-danger' : 'text-muted not-enabled'}
            title={translations.deprioritized}
            fixedWidth
            onClick={() => update('deprioritize')}
          />
          <IconPlay
            className={mode === 'normal' ? 'text-info' : 'text-muted not-enabled'}
            title={translations.normal}
            fixedWidth
            onClick={() => update('normal')}
          />
          <IconForwardFast
            className={mode === 'prioritize' ? 'text-success' : 'text-muted not-enabled'}
            fixedWidth
            title={translations.prioritized}
            onClick={() => update('prioritize')}
          />
        </>
      )}
    </Stack>
  );
};

export default memo(TableCell);
